<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <div>
      <h6
        class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
      >
        {{ $t("product.条件筛选") }}
      </h6>
      <div class="mg-t-10 pd-x-10 mg-b-40">
        <div class="form-group mg-b-15">
          <input
            type="text"
            :placeholder="$t('product.相册名称')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate()"
            v-model.trim="kName"
          />
        </div>
        <div class="form-group mg-b-15">
          <select
            class="form-control form-control-dark"
            v-model="kStatus"
            @change="filtrate"
          >
            <option value="">{{ $t("product.状态") }}</option>
            <option v-for="(s, k) in $dict.imgsStatus" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
        <div class="form-group mg-b-15">
          <select
            class="form-control form-control-dark"
            v-model="kType"
            @change="filtrate"
          >
            <option value="">{{ $t("product.类型") }}</option>
            <option v-for="(s, k) in $dict.imgsType" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium"
      @click="filtrate"
    >
      {{ $t("product.筛 选") }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["status", "keyStatus", "keyType", "keyName"],
  data() {
    return {
      kStatus: "",
      kType: "",
      kName: "",
    };
  },
  watch: {
    keyName() {
      this.kName = this.keyName;
    },
    keyStatus() {
      this.kStatus = this.keyStatus;
    },
    keyType() {
      this.kType = this.keyType;
    },
  },
  methods: {
    filtrate() {
      this.$emit("filtrate", this.kStatus, this.kType, this.kName);
    },
  },
  mounted() {},
  updated() {},
};
</script>